import { CKButton } from '@clearkit/react';
import { Link } from 'react-router-dom';

import paths from '~/lib/paths';

function EmptyPlaceholder({ integrate }) {
  return (
    <div className="flex flex-col items-center text-center w-xxs">
      <h1 className="mt-4 mb-1 text-base font-medium text-gray-600">
        Nothing to show
      </h1>

      {integrate && (
        <>
          <p className="px-4 mb-4 text-sm text-gray">
            You may need to integrate the Clearbit Tag or Segment into your app
            to begin the data flow.
          </p>
          <CKButton as={Link} to={paths.configurations()} isSmall>
            Configure now
          </CKButton>
        </>
      )}
    </div>
  );
}

EmptyPlaceholder.propTypes = {
  integrate: PropTypes.bool,
};

export default EmptyPlaceholder;
